export default __webpack_public_path__ + "locales/sk/SharingPanel.json?hash=293728a6c4c1f99cc45a1890ab74072a";